module.exports = __webpack_public_path__ + "img/_4.2fb90664.png";